import { render, staticRenderFns } from "./DataArea.vue?vue&type=template&id=2ff226cf"
import script from "./DataArea.vue?vue&type=script&lang=js"
export * from "./DataArea.vue?vue&type=script&lang=js"
import style0 from "./DataArea.vue?vue&type=style&index=0&id=2ff226cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports